import { render, staticRenderFns } from "./EditLibraryModal.vue?vue&type=template&id=63fe7bb0&lang=pug&"
import script from "./EditLibraryModal.vue?vue&type=script&lang=js&"
export * from "./EditLibraryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports